import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/markets", label: "Stocks", id: "nav-markets-link" },
  { to: "/properties", label: "Real Estate", id: "nav-properties-link" },
  { to: "/contact", label: "Contact", id: "nav-contact-link" },
];

const linkCls = ({ isActive }) =>
  `text-sm transition-colors duration-200 ${isActive ? "text-white" : "text-slate-400 hover:text-white"}`;

function AccountActions({ mobile = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const suffix = mobile ? "-mobile" : "";
  if (user?.role === "client" || user?.role === "admin") {
    const isAdmin = user.role === "admin";
    return (
      <div className={`flex ${mobile ? "flex-col" : "items-center"} gap-3`}>
        <Link to={isAdmin ? "/admin" : "/dashboard"} className="btn-ghost !px-4 !py-2" data-testid={`nav-dashboard-button${suffix}`}>
          {isAdmin ? <ShieldCheck className="h-4 w-4" /> : <LayoutDashboard className="h-4 w-4" />}
          {isAdmin ? "Admin panel" : "My portfolio"}
        </Link>
        <button
          onClick={async () => { await logout(); navigate("/"); }}
          className="inline-flex items-center gap-2 py-2 text-sm text-slate-400 transition-colors hover:text-white"
          data-testid={`nav-logout-button${suffix}`}
        >
          <LogOut className="h-4 w-4" /> Log out
        </button>
      </div>
    );
  }
  return (
    <div className={`flex ${mobile ? "flex-col" : "items-center"} gap-3`}>
      <Link to="/login" className="btn-ghost !px-5 !py-2" data-testid={`nav-login-button${suffix}`}>Log in</Link>
      <Link to="/register" className="btn-primary !px-5 !py-2" data-testid={`nav-register-button${suffix}`}>Open account</Link>
    </div>
  );
}

export default function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-slate-800 bg-obsidian/80 backdrop-blur-xl" data-testid="site-header">
      <div className="container-x flex h-[72px] items-center justify-between">
        <Logo />
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkCls} data-testid={l.id}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="hidden md:block"><AccountActions /></div>
        <Sheet>
          <SheetTrigger className="flex h-11 w-11 items-center justify-center rounded-xl border border-line md:hidden" data-testid="nav-mobile-menu-button" aria-label="Open menu">
            <Menu className="h-5 w-5" />
          </SheetTrigger>
          <SheetContent side="right" className="border-line bg-obsidian">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="mt-10 flex flex-col gap-6">
              {LINKS.map((l) => (
                <NavLink key={l.to} to={l.to} className="py-1 font-display text-2xl text-slate-200" data-testid={`${l.id}-mobile`}>{l.label}</NavLink>
              ))}
              <AccountActions mobile />
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
